import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Hidden from '@mui/material/Hidden'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'

import LinkChild from '@src/lib/LinkChild'

import { deleteOmniauthCookies } from '../auth/omniauthHelpers'
import BusinessSelector from '../shared/BusinessSelector'
import CommonTop from '../shared/CommonTop'
import NeedHelp from '../shared/NeedHelp'

const useStyles = makeStyles()(() => ({
  businessSelector: {
    marginTop: '-250px',
  },
}))

export const AccountSelector = () => {
  const retailerAccounts =
    useSelector((state) => {
      return state.auth && state.auth.user && state.auth.user.retailer_accounts
    }).sort((a, b) => {
      const name1 = a.name.toLowerCase()
      const name2 = b.name.toLowerCase()
      return name1 < name2 ? -1 : 1
    }) || []
  const { slug } = retailerAccounts[0] || {}
  const { classes } = useStyles()
  const history = useHistory()
  const [isSelected, setIsSelected] = useState(false)

  const user =
    useSelector((state) => {
      return state.auth && state.auth.user && state.auth.user
    }) || null

  const sendToContentPage = (slug) => {
    //Redirects should be already handled elsewhere...
    history.push(`/retailer/content/${slug}/all`)
  }

  const handleRetailerClick = (retailerAccount) => {
    setIsSelected(true)
    sendToContentPage(retailerAccount.slug)
  }

  const name =
    user.first_name && user.last_name
      ? `${user.first_name} ${user.last_name}`
      : ''

  useEffect(() => {
    if (!retailerAccounts || retailerAccounts.length === 0) {
      window.location.href = '/#/login/manageEnrollment'
    } else if (retailerAccounts && retailerAccounts.length === 1) {
      sendToContentPage(slug)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retailerAccounts.length, slug])

  return (
    <>
      <CommonTop />
      <Grid className={classes.businessSelector} container>
        <Grid item sm={3} xs={0} />
        <Grid item sm={6} xs={12}>
          <Paper elevation={3}>
            <Box p={4}>
              <Grid container spacing={2}>
                <Grid item sm={10}>
                  <Grid container spacing={4}>
                    <Hidden smDown>
                      <Grid display={{ xs: 'none' }} item>
                        <Avatar alt={name} style={{ width: 65, height: 65 }} />
                      </Grid>
                    </Hidden>
                    <Grid item>
                      {name && <Typography variant={'h6'}>{name}</Typography>}
                      <Typography variant={'subtitle1'}>
                        {user.email}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  alignItems={'center'}
                  component={Box}
                  display={'flex'}
                  item
                  justifyContent={'flex-end'}
                  sm={2}
                >
                  <LinkChild
                    to="/login"
                    onClick={() => {
                      deleteOmniauthCookies()
                    }}
                  >
                    <Button color="secondary" variant="outlined">
                      {I18n.t('shared.logout')}
                    </Button>
                  </LinkChild>
                </Grid>
              </Grid>
              <Box mb={2} mt={4}>
                <Divider />
              </Box>
              <Typography variant={'h5'}>
                {I18n.t('nav.selectABusiness')}
              </Typography>
              <BusinessSelector
                handleRetailerClick={handleRetailerClick}
                working={isSelected}
              />
              <Box display={'flex'} justifyContent={'center'} width={'100%'}>
                <NeedHelp />
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}

export default AccountSelector
